<script>

import config from '@/common/genericPanelConf';
import GenericDataTable from '@/components/generic/GenericDataTable.vue';
import Service from '@/services/planning';
import OperativeLevelsImport from '@/components/planning/OperativeLevelsImport.vue';

export default {
    props: ['category', 'name'],
    components: {
        GenericDataTable,
        OperativeLevelsImport
    },
    data(){
        return{
            configuration: null,
            importExcelVisible: false,
        }
    },
    created(){
        this.configuration = config.getConfiguration(this.name);
        if(this.configuration){
            this.$store.dispatch('security/setNavbarTitle', this.configuration.title);
        }
    },
    mounted(){
        
    },
    methods: {
        onAdd(){
            let uri = `/${this.category}/${this.name}/0`;
            this.$router.push(uri);
        },
        downloadExcelTemplate(){
            this.$store.dispatch("generic/setLoading", true);

            Service.downloadOperativeLevelsExcelTemplate({}, ({success, data, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                
                if(success){
                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    let fileName = `Template.xlsx`
                    fileLink.setAttribute('download', fileName);
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                } else{
                    this.$toast.add({ detail: message || this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        openImportExcel(){
            this.importExcelVisible = true;
        },
        hideImportDialog(response){
            this.importExcelVisible = false;
            this.$refs.opLevelsDataTable.loadData();
        }
    },
    computed: {
        conf(){
            return config;
        }
    }
}
</script>



<template>
    <div class="" style="height: 80vh;">
        <Dialog v-model:visible="importExcelVisible" modal :style="{ width: '85vw'}">
            <OperativeLevelsImport :showCreate="true" :showLink="false" @hide-dialog="hideImportDialog"/>
        </Dialog>
    <GenericDataTable :configuration="configuration" :category="category" :name="name" 
            ref="opLevelsDataTable"
            @onOperativeLevelsDownloadExcelTemplate="downloadExcelTemplate"
            @onOperativeLevelsImportExcel="openImportExcel" />
    </div>
</template>